import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ContentHeaderKey } from "src/app/constants/content-header";
import { ResourceLink } from "src/app/models/resource-link";
import { DocumentService } from "src/app/services/documents.service";

@Component({
    selector: 'mwp-member-resourcs-benefits',
    templateUrl: './benefit.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MemberDocumentBenefitsComponent implements OnInit {

    public resources: ResourceLink[];
    public apiUrl = ContentHeaderKey.DocumentsBenefits;

    constructor(
        private documentService: DocumentService
    ) {
    }

    ngOnInit(): void {
        this.documentService.getBenefitResources().subscribe((response: ResourceLink[]) => {
            this.resources = response;
        });
    }

    public openTab(url: string): void {
        window.open(url, "_blank");
    }
}